import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { hospitalFormat, formateImageWebp } from '../../utils';
import styles from './index.less';
export var HospitalHeader = function (props) {
    var hospitalData = props.hospitalData, type = props.type, children = props.children, style = props.style;
    var _a = useComponents(), View = _a.View, Image = _a.Image, Text = _a.Text;
    var establishLogic = hospitalFormat.establishTime(hospitalData.establishmentDate);
    return (React.createElement(View, { className: styles['hospital-head'], style: style },
        React.createElement(View, { className: styles['hospital-header'] },
            React.createElement(View, { className: styles['hospital-container'] },
                React.createElement(Image, { className: styles['hospital-header-logo'], src: formateImageWebp(hospitalData.logo), imageWidth: 160, imageHeight: 160 }),
                React.createElement(View, { className: styles['hospital-header-info'] },
                    React.createElement(Text, { className: styles['hospital-name'], content: hospitalData.name }),
                    React.createElement(View, { className: styles['hospital-tags'] },
                        React.createElement(View, { className: styles['tag-authentic'] },
                            React.createElement(View, { className: styles['tag-authentic-img'] }),
                            React.createElement(View, { className: styles['tag-authentic-content'] }, "\u8D44\u8D28\u8BA4\u8BC1")),
                        establishLogic.showYearTag && (React.createElement(View, { className: styles['tag-time'] },
                            "\u6210\u7ACB ",
                            establishLogic.diffYear,
                            " \u5E74"))),
                    type === 'fixed' && (React.createElement(React.Fragment, null,
                        React.createElement(View, { className: styles['dec-container'] },
                            React.createElement(Text, { className: styles['hospital-dec'], content: hospitalData.desc }),
                            React.createElement(Image, { className: styles['arrow-right'], src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/arrow-right.png", imageWidth: 11, imageHeight: 11 })))))),
            React.createElement(View, { className: styles['hospital-dynamic'] }, children)),
        type !== 'fixed' && (React.createElement(View, { className: styles['hospital-info-conatiner'] },
            React.createElement(View, { className: styles['hospital-info'] + " " + styles['info-address'] },
                React.createElement(View, { className: styles['info-logo'] }),
                hospitalData.location),
            React.createElement(View, { className: styles['hospital-info'] },
                React.createElement(View, { className: styles['info-logo'] + " " + styles['logo-time'] }),
                hospitalData.serviceTime)))));
};
